<template>
    <div class="card mb-2 mt-2 ms-5 me-5">
        <div class="card-body">
            <h4 class="mt-3 mb-2">
                <strong>Servicios a realizar</strong>
            </h4>
            <div class="table-responsive">
                <table class="mx-auto">
                    <thead>
                        <tr colspan="8"></tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="lblform"><strong>Longitud de corte en cizalla: </strong>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountShearCut" type="number" min="0" step="50"
                                    class="form-control avilable-input" v-model="shearCutService"
                                    @change="calculateShearCut" placeholder="0" />Digite en
                                centímetros.
                            </td>
                            <td class="lblform"><strong>Longitud de dobleces:</strong></td>
                            <td class="inputForm">
                                <input id="sheetAmountFold" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="foldService"
                                    @change="calculateFold" />Digite en
                                centímetros.
                            </td>
                            <td class="lblform"><strong>Peso para rolado recto:</strong>
                                <br>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" role="switch" id="rolledService"
                                        v-model="requestRolledService" @change="useRolled" />
                                    <label class="form-check-label ms-1" for="rolledService"><i>Utilizar
                                            servicio</i></label>
                                </div>
                                <div>
                                    <i><strong>Precio por kilo: {{ priceKiloRolled }}</strong></i>
                                </div>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountRolled" type="number" min="0" step="1" placeholder="0"
                                    class="form-control avilable-input" v-model="rolledService"
                                    @change="calculateRolled" />Digite en
                                Kilos.
                            </td>
                            <td class="lblform"><strong>Longitud de <br>soldadura con electrodo:</strong></td>
                            <td class="inputForm">
                                <input id="sheetAmountWeldingElectrode" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="weldingElectrodeService"
                                    @change="calculateWeldingMig" />Digite en centímetros.
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Longitud de corte en plasma:</strong>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountPlasmaCutting" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="plasmaService"
                                    @change="calculatePlasmaCutting" />Digite
                                en centímetros.
                            </td>
                            <td class="lblform">
                                <strong> Cantidad de agujeros, <br> punzonados o destijeres.</strong> <br> Menores a
                                40mm:
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountPunched1" type="number" min="0" step="1" placeholder="0"
                                    class="form-control avilable-input" v-model="punching1Service"
                                    @change="calculatePunching1" /> Unidades.
                            </td>
                            <td class="lblform"><strong>Peso para rolado cónico:</strong>
                                <br>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" role="switch" id="rolledCService"
                                        v-model="requestRolledCService" @change="useRolledC" />
                                    <label class="form-check-label ms-1" for="rolledCService"><i>Utilizar
                                            servicio</i></label>
                                </div>
                                <div>
                                    <i><strong> Precio por kilo: {{ priceKiloRolledC }}</strong></i>
                                </div>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountRolledC" type="number" min="0" step="1"
                                    class="form-control avilable-input" placeholder="0" v-model="conicalRolledService"
                                    @change="calculateConicalRolled" />Digite en
                                Kilos.
                            </td>
                            <td class="lblform"><strong>Longitud de <br>
                                    soldadura con MIG:</strong></td>
                            <td class="inputForm">
                                <input id="sheetAmountWeldingMig" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="weldingMigService"
                                    @change="calculateWeldingElectrode" />Digite en
                                centímetros.
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Longitud de corte con laser:</strong>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountLaserCutting" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="laserService"
                                    @change="calculateLaserCutting" />Digite
                                en centímetros.
                            </td>
                            <td class="lblform">
                                <strong>Cantidad de agujeros, <br> punzonados o destijeres.</strong> <br> Mayores a
                                40mm:
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountPunched2" type="number" min="0" step="1" placeholder="0"
                                    class="form-control avilable-input" v-model="punching2Service"
                                    @change="calculatePunching2" />Unidades.
                            </td>
                            <td class="lblform"><strong>Peso para abombado:</strong>
                                <br>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" role="switch" id="convexService"
                                        v-model="requestConvexService" @change="useConvex" />
                                    <label class="form-check-label ms-1" for="convexService"><i>Utilizar
                                            servicio</i></label>
                                </div>
                                <div>
                                    <i><strong>Precio por kilo: {{ priceKiloConvex }}</strong></i>
                                </div>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountConvex" type="number" min="0" step="1" placeholder="0"
                                    class="form-control avilable-input" v-model="convexService"
                                    @change="calculateConvex" />Digite en
                                Kilos.
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Longitud de oxicorte:</strong>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountFlameCutting" type="number" min="0" step="50" placeholder="0"
                                    class="form-control avilable-input" v-model="flameCuttingService"
                                    @change="calculateFlameCutting" />Digite
                                en centímetros.
                            </td>
                            <td></td>
                            <td></td>
                            <td class="lblform"><strong>Peso para pestañado:</strong>
                                <br>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" role="switch" id="eyelashedService"
                                        v-model="requestEyelashedService" @change="useEyelashed" />
                                    <label class="form-check-label ms-1" for="eyelashedService"><i>Utilizar
                                            servicio</i></label>
                                </div>
                                <div>
                                    <i><strong>Precio por kilo: {{ priceKiloEyelashed }}</strong></i>
                                </div>
                            </td>
                            <td class="inputForm">
                                <input id="sheetAmountEyelashed" type="number" min="0" step="1" placeholder="0"
                                    class="form-control avilable-input" v-model="eyelashedService"
                                    @change="calculateEyelashed" />Digite en
                                Kilos.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <p> <strong>Precio de otros servicios: </strong> <br> (Manipulación, transporte,
                                    embalaje,
                                    etc.)</p>
                            </td>
                            <td>
                                <p><strong>$</strong></p>
                            </td>
                            <td><input id="sheetAmountOther" type="number" min="0" class="form-control avilable-input"
                                    placeholder="0" step="1000" v-model="otherService"
                                    @change="useOtherService" />Digite
                                el
                                valor en pesos.</td>
                            <td><strong>Observaciones adiconales:</strong> </td>
                            <td colspan="3">
                                <textarea class="" id="sheetComments" type="text" v-model="comments"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getMainSheetType: Number,
        getWeight: Number,
    },
    data() {
        return {
            // Calculo de servicios en metros, kilos y unidades - Campos de servicios
            shearCutService: 0,
            foldService: 0,
            plasmaService: 0,
            laserService: 0,
            flameCuttingService: 0,
            rolledService: 0,
            conicalRolledService: 0,
            punching1Service: 0,
            punching2Service: 0,
            weldingElectrodeService: 0,
            weldingMigService: 0,
            convexService: 0,
            eyelashedService: 0,
            otherService: 0,
            comments: "",
            //Usar algunos servicios de cálculo automático
            requestRolledService: false,
            requestRolledCService: false,
            requestConvexService: false,
            requestEyelashedService: false,
            //Valor acumulado en pesos de los servicios
            totalService: 0,
            //Alertas sobre el espesor de la lamina y la facilidad del servicio
            generalAlert: "Servicio no disponible, para el espesor comercial solicitado.",
            //Precio por kilos
            priceKiloRolled: 0,
            priceKiloRolledC: 0,
            priceKiloConvex: 0,
            priceKiloEyelashed: 0,
        }
    },
    watch: {
        shearCutService: 'calculateServices',
        plasmaService: 'calculateServices',
        laserService: 'calculateServices',
        flameCuttingService: 'calculateServices',
        foldService: 'calculateServices',
        punching1Service: 'calculateServices',
        punching2Service: 'calculateServices',
        rolledService: 'calculateServices',
        conicalRolledService: 'calculateServices',
        convexService: 'calculateServices',
        eyelashedService: 'calculateServices',
        weldingElectrodeService: 'calculateServices',
        weldingMigService: 'calculateServices',
        otherService: 'calculateServices',
        getMainSheetType(newVal) {
            if (newVal !== null) {
                // console.log("Desde el hijo", this.getMainSheetType);
                this.getSheetTypeById();
            }
        },
        getWeight(newVal) {
            if (newVal !== null) {
                // console.log("Peso: ", this.getWeight);
            }
        },
    },
    methods: {
        async getSheetTypeById() {
            if (this.getMainSheetType == 0) {
                console.log("Id de clasificación de lámina.");
            } else {
                try {
                    let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/get", {
                        params: {
                            sheetType_id: this.getMainSheetType,
                        },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    });
                    // console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        //console.log(res.data);
                        this.sheetTypeInfo = res.data[0];
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
            this.priceKiloRolled = this.sheetTypeInfo["priceRolled"];
            this.priceKiloRolledC = this.sheetTypeInfo["priceRolledConical"];
            this.priceKiloConvex = this.sheetTypeInfo["priceConvex"];
            this.priceKiloEyelashed = this.sheetTypeInfo["priceEyelashed"];
        },
        calculateServices() {
            this.totalService = 0; // Reinicia totalService
            this.totalService += this.calculateShearCut();
            this.totalService += this.calculateFold();
            this.totalService += this.calculateFlameCutting();
            this.totalService += this.calculatePlasmaCutting();
            this.totalService += this.calculateLaserCutting();
            this.totalService += this.calculatePunching1();
            this.totalService += this.calculatePunching2();
            this.totalService += this.calculateRolled();
            this.totalService += this.calculateConicalRolled();
            this.totalService += this.calculateConvex();
            this.totalService += this.calculateEyelashed();
            this.totalService += this.calculateWeldingElectrode();
            this.totalService += this.calculateWeldingMig();
            this.totalService += this.calculateOtherServices();
            // console.log("Emit servicios al cambio: ", this.totalService);
            this.$emit("sendTotalServices", this.totalService);
        },
        calculateShearCut() {
            // let price = (this.shearCutService / 100) * this.sheetTypeInfo.priceShearCut;
            // console.log("Corte 1", price)
            return (this.shearCutService / 100) * this.sheetTypeInfo.priceShearCut;
        },
        calculatePlasmaCutting() {
            return (this.plasmaService / 100) * this.sheetTypeInfo.pricePlasmaCutting;
        },
        calculateLaserCutting() {
            return (this.laserService / 100) * this.sheetTypeInfo.priceLaserCutting;
        },
        calculateFlameCutting() {
            return (this.flameCuttingService / 100) * this.sheetTypeInfo.priceFlameCutting;
        },
        calculateFold() {
            return (this.foldService / 100) * this.sheetTypeInfo.priceFold;
        },
        calculateWeldingElectrode() {
            return (this.weldingElectrodeService / 100) * this.sheetTypeInfo.priceWeldingElectrode;
        },
        calculateWeldingMig() {
            return (this.weldingMigService / 100) * this.sheetTypeInfo.priceWeldingMig;
        },
        useRolled() {
            this.calculateRolled();
        },
        calculateRolled() {
            if (this.requestRolledService) {
                //let rolled = this.roundServiceWeight(this.getWeight);
                this.rolledService = this.getWeight;
                return this.rolledService * this.sheetTypeInfo.priceRolled;
            } else {
                this.rolledService = 0;
                this.requestRolledService = false;
                return 0;
                // console.log("El servicio no aplica")
            }
        },
        useRolledC() {
            this.calculateConicalRolled();
        },
        calculateConicalRolled() {
            if (this.requestRolledCService) {
                //let conicalRolled = this.roundServiceWeight(this.getWeight);
                this.conicalRolledService = this.getWeight;
                return this.conicalRolledService * this.sheetTypeInfo.priceRolledConical;
            } else {
                this.conicalRolledService = 0;
                this.requestRolledCService = false;
                return 0;
                // console.log("El servicio no aplica")
            }
        },
        calculatePunching1() {
            return this.punching1Service * this.sheetTypeInfo.pricePunching1;
        },
        calculatePunching2(diametre) {
            return this.punching2Service * this.sheetTypeInfo.pricePunching2;
        },
        useConvex() {
            this.calculateConvex();
        },
        calculateConvex() {
            if (this.requestConvexService) {
                this.convexService = this.getWeight;
                return this.convexService * this.sheetTypeInfo.priceConvex;
            } else {
                this.convexService = 0;
                this.requestConvexService = false;
                return 0;
                // console.log("El servicio no aplica")
            }
        },
        useEyelashed() {
            this.calculateEyelashed();
        },
        calculateEyelashed() {
            if (this.requestEyelashedService) {
                this.eyelashedService = this.getWeight;
                return this.eyelashedService * this.sheetTypeInfo.priceEyelashed;
            } else {
                this.eyelashedService = 0;
                this.requestEyelashedService = false;
                return 0;
                // console.log("El servicio no aplica")
            }
        },
        calculateOtherServices() {
            return this.otherService;
        },
        roundServiceMeters(number) {
            if (number >= 1 && number <= 100) {
                return 100;
            } else if (number > 100 && number <= 200) {
                return 200;
            } else if (number > 200 && number <= 300) {
                return 300;
            }
            else if (number > 300 && number <= 400) {
                return 400;
            }
            else if (number > 400 && number <= 500) {
                return 500;
            }
            else if (number > 500 && number <= 600) {
                return 600;
            }
            else if (number > 600 && number <= 700) {
                return 700;
            }
            else if (number > 700 && number <= 800) {
                return 800;
            }
            else if (number > 800 && number <= 900) {
                return 900;
            }
            else if (number > 900 && number <= 1000) {
                return 1000;
            }
            else if (number > 1000 && number <= 1100) {
                return 1100;
            }
            else if (number > 1100 && number <= 1200) {
                return 1200;
            }
            else if (number > 1300 && number <= 1400) {
                return 1300;
            }
            else if (number > 1400 && number <= 1500) {
                return 1400;
            }
            else if (number > 1500 && number <= 1600) {
                return 1500;
            }
            else {
                // Si el número no coincide con ninguna de las condiciones anteriores, devolvemos el número sin redondear.
                return number;
            }
        },
    },
}
</script>
<style scoped>
.card {
    border: solid 2px #a6323b;
}

input [type="number"] {
    padding: 2px 6px 2px 16px;
    border: solid 5px #999999;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

textarea {
    min-width: 500px;
    min-height: 80px;
}

.avilable-input {
    background-color: #FCE196;
}
</style>